import HomePage from './HomePage.vue';

const routes = [
  // Désactivé - conflit avec le module tickets qui utilise '/' comme homepage
  // {
  //   path: '/',
  //   redirect: '/home'
  // },
  {
    path: '/home',
    name: 'home',
    component: HomePage,
    meta: {
      title: 'Dashboard',
      requiresAuth: true
    }
  }
];

export default routes;
